<template>
  <PaFrontForm
    class="pa-message-additional-box"
    :class="additionalFormClass"
    :action="'/'"
    :formSetClass="['form-set-primary']"
    :formSet="formSet"
    :submitText="'変更'"
    :submitLoading="isFormLoading"
    :isDisabledButton="isDisabledButton"
    :validationMessagePosition="'bottom'"

    :hasSubmitButton="false"
    :hasCancelButton="false"
    
    @handleSubmit="handleSubmit"
    @handleCancel="handleCancel"
    @handleChangeSwitch="handleChangeSwitch"
  />
</template>

<script>
import FormValidationControlMixin from '@/mixins/FormValidationControlMixin.js'

import PaFrontForm from '@/components/FrontParts/PaFrontForm/PaFrontForm.vue'

import {GetUserMeta}  from '@/graphql/queries/User.graphql'

export default {
  props : {
    isLoading   : {
      default: false,
    },

    isDisabled  : {
      default: false,
    },

    serverValidationError : {
      default: null
    },
  },
  
  mixins : [
    FormValidationControlMixin
  ],

  components : {
    PaFrontForm
  },

  data(){
    return {
      isFormLoading : false,

      formSet       : {
        isEnableCharacterLevelUpModal : {
          label           : '異界舞踏会経験値上昇時の飛出通知',
          switchLabel     : '表示する',
          validationRules : [],
          inputType       : 'switch',
          isDisabled      : false,
        },
        
        isEnableGetItemModal  : {
          label           : 'アイテムを入手時の飛出通知',
          switchLabel     : '表示する',
          validationRules : [],
          inputType       : 'switch',
          isDisabled      : false,
        },
      },

      isDisabledFormFields  : false,

      additionalFormClass : [],

      userMeta            : null,
    }
  },

  apollo : {
    userMetaList: {
      query: GetUserMeta
    }
  },

  computed : {
    queryLoading(){
      if(typeof this.$apollo.queries.userMetaList === 'undefined') return false;

      return this.$apollo.queries.userMetaList.loading;
    }
  },

  watch : {
    queryLoading(value){
      this.isFormLoading = value;
    },

    userMetaList : {
      handler(data){
        if(typeof data === 'undefined') return;

        this.userMeta = JSON.parse(data.data);
      },
      immediate: true,
      deep: true
    },

    userMeta : {
      handler(data){
        if(data === null) return;
        if(typeof data !== 'object') return;
        
        const mutateDataSet = {
          'modalNotifications.isEnableCharacterLevelUpModal' : 'isEnableCharacterLevelUpModal',
          'modalNotifications.isEnableGetItemModal'          : 'isEnableGetItemModal'
        };

        for(let i in mutateDataSet){
          if(typeof data[i] !== 'undefined'){
            this.formSet[mutateDataSet[i]].value = data[i];
          }
        }
      },
      immediate: true,
      deep: true
    },

    isDisabled  : {
      handler(value){
        if(value === true){
          this.isDisabledButton     = true;
          this.buttonClass          = ['button-disabled'];
          this.additionalFormClass  = ['pa-message-additional-box-disabled'];

          this.isDisabledFormFields = true;
        }else{
          this.isDisabledButton     = false;
          this.buttonClass          = [];
          this.additionalFormClass  = [];

          this.isDisabledFormFields = false;
        }
      },
      immediate: true
    },

    isLoading   : {
      handler(value){
        if(value === true){
          this.isFormLoading = true;
        }else{
          this.isFormLoading = false;
        }
      }
    },

    isFormLoading : {
      handler(value){
        this.isDisabledFormFields = value;
      }
    },

    isDisabledFormFields  : {
      handler(value){
        if(value === true){
          this.disabledFields();
        }else{
          this.unDisabledFields();
        }
      },
      immediate: true
    },

    serverValidationError : {
      handler(data){
        if(data === null) return;
        console.log(data);
        if(data.first.category === 'validation'){
          this.unValidateField({
            fieldName : data.first.field,
            message   : data.first.message,
          });
        }
      },
      immediate: true,
      deep:true
    }
  },

  methods : {
    handleSubmit(){
      if( this.checkFormPreValidation() ){
        this.$emit('onSubmit', this.formSet);
      }else{
        console.log('validation error');
      }
    },
    
    handleCancel(){
      this.$emit('onCancel');
    },

    handleChangeSwitch(fieldName){
      this.$emit('onSubmit', this.formSet, {
        inProgressField : fieldName
      });
    }
  }
}
</script>

<style lang="scss">
  @import "@/components/Pages/Office/MessageApp/MessageAppForm.scss";
</style>